module.exports = __webpack_public_path__ + "img/Septris-sprite-02.cad9d362.png";